import Head from 'next/head'; 
import React from "react";
import Link from "next/link";

const Error = () => {
  return (
    <>
      <Head>
        <title>منصة تقنين | صفحة مفقودة</title>
        <meta name="description" content="معلومات عن منصة تقنين" />
      </Head>
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 text-center">
        <h1 className="text-6xl font-bold text-gray-800 dark:text-white">404</h1>
        <p className="text-xl text-gray-600 dark:text-gray-300 mt-2">
          الصفحة غير موجودة
        </p>
        <Link
          href="/"
          className="mt-4 px-6 py-2 text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition"
        >
          العودة إلى الصفحة الرئيسية
        </Link>
      </div>
    </>
  );
};

export default Error;
